import { mapActions, mapGetters } from 'vuex';
import twitter from '@/components/twitter/twitter';
import { MODALS } from '@/components/app/app-modals/modals-constants';

function styleTwitterTimeline($content) {
  if ($content) {
    const style = document.createElement('style');
    style.innerHTML += 'a {color:#67999f;}';
    style.innerHTML += '.timeline-Widget {padding:19px 13px;}';
    style.innerHTML += '.timeline-Header {margin-bottom:9px;padding:0;}';
    style.innerHTML += '.timeline-Header-title {color:#263b3f;font-size:26px;line-height:17px;letter-spacing:0.03em;font-weight:500;}';
    style.innerHTML += '.timeline-Header-byline {color:#263b3f;}';
    style.innerHTML += '.SandboxRoot.env-bp-430 .timeline-Tweet-text {font-size:14px;line-height:18px;font-weight:500;color:#263b3f;}';
    style.innerHTML += '.timeline-TweetList-tweet {border-top:1px solid #b8c5c6;}';
    style.innerHTML += '.timeline-Body {border-top:1px solid #b8c5c6;border-bottom:1px solid #b8c5c6;}';
    const head = $content.getElementsByTagName('head');

    if (head && head.length > 0) {
      head[0].appendChild(style);
    }
  }
}

function createTimeline(twt, el, limit = -1, callback = null) {
  const width = (window.innerWidth > 0) ? window.innerWidth : screen.width;

  const options = {
    chrome: 'nofooter',
  };

  if (width <= 320) {
    options.width = 300;
  }

  if (limit !== -1) options.tweetLimit = limit;
  twt.widgets
  .createTimeline(
    {
      sourceType: 'profile',
      screenName: process.env.TWITTER_HANDLE,
    },
    el,
    options,
  )
  .then((iframeEl) => {
    if (!iframeEl) return;
    // const $content = iframeEl.contentDocument;
    // styleTwitterTimeline($content);

    if (callback !== null && typeof callback === 'function') {
      callback();
    }
  });
}

export default {
  props: {
    inOverlay: {
      type: Boolean,
      default: false,
    },
    theme: {
      type: String,
      default: '',
    },
    numTweets: {
      type: Number,
      default: 6,
    },
  },
  data() {
    return {
      identifier: +new Date(),
      loading: false,
      ready: false,
      hideFooter: false,
    };
  },
  computed: {
    ...mapGetters('app', ['isLayoutDesktop', 'isShutdownModeOn']),
    getMoreTweetsLabel() {
      return this.isLayoutDesktop ? 'More Tweets' : 'Load more';
    },
    classModifiers() {
      return {
        twittertimeline: true,
        'twittertimeline--loading': this.loading,
      };
    },
    initClassModifiers() {
      return {
        'twittertimeline__iframe-wrapper': true,
        [`twittertimeline__iframe-wrapper--${this.identifier}`]: this.identifier,
      };
    },
    contentClassModifiers() {
      return {
        twittertimeline__content: true,
        'twittertimeline__content--shutdown': this.isShutdownModeOn,
        [`twittertimeline__content--${this.theme}`]: this.theme,
      };
    },
    showFooter() {
      return !this.inOverlay && !this.hideFooter;
    },
    tweetLimit() {
      return !this.inOverlay ? this.numTweets : undefined;
    },
  },
  methods: {
    ...mapActions('popup', ['setCurrentPopup']),
    onFooterMoreButtonClick(e) {
      e.stopPropagation();
      if (this.isLayoutDesktop) {
        this.setCurrentPopup(MODALS.TWITTER);
      } else {
        this.loading = true;
        twitter().ready(twt => createTimeline(twt, this.$refs.more, undefined, () => {
          this.loading = false;
          this.hideFooter = true;
          this.$refs.init.remove();
        }));
      }
    },
  },
  mounted() {
    this.loading = true;
    setTimeout(() => {
      this.loading = false;
    }, 5000);
    this.$nextTick(() => {
      twitter().ready((twt) => {
        twt.events.bind('loaded', () => {
          this.loading = false;
          this.ready = true;
        });
        createTimeline(twt, this.$refs.init, this.tweetLimit, () => {
          this.loading = false;
        });
      });
    });
  },
};



// WEBPACK FOOTER //
// ./src/components/twitter/twitter-timeline/twitter-timeline.js